import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import QRWizard from "../components/QRWizard";

function ScanRedirect() {
  const { qrCode } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [showWizard, setShowWizard] = useState(false);
  const [resolvedQrCode, setResolvedQrCode] = useState(null);

  useEffect(() => {
    async function resolveQrCode() {
      try {
        const response = await api.get(`/qr/resolve/${qrCode}`);
        const { type, entity, qr_code } = response.data;

        if (type === "entity") {
          // QR code is assigned to an entity - go to entity detail
          navigate(`/entity/${entity.id}`, { replace: true });
        } else {
          // Unassigned, or any shape we don't recognise: offer to create an
          // entity rather than sitting on the spinner forever.
          setResolvedQrCode(qr_code?.code || qrCode);
          setShowWizard(true);
        }
      } catch (err) {
        console.error("Failed to resolve QR code:", err);
        setError(err.response?.data?.error || "QR code not found or invalid");
        setTimeout(() => navigate("/", { replace: true }), 3000);
      }
    }

    if (qrCode) {
      resolveQrCode();
    }
  }, [qrCode, navigate]);

  const handleWizardComplete = (entityId) => {
    navigate(`/entity/${entityId}`, { replace: true });
  };

  const handleWizardCancel = () => {
    navigate("/", { replace: true });
  };

  if (showWizard && resolvedQrCode) {
    return (
      <QRWizard
        qrCode={resolvedQrCode}
        onComplete={handleWizardComplete}
        onCancel={handleWizardCancel}
      />
    );
  }

  if (error) {
    return (
      <div
        className="container"
        style={{ marginTop: "20vh", textAlign: "center" }}
      >
        <div
          className="card"
          style={{ padding: "2rem", maxWidth: "400px", margin: "0 auto" }}
        >
          <h2
            style={{ color: "var(--accent-danger)", marginBottom: "1rem" }}
          >
            Error
          </h2>
          <p>{error}</p>
          <p
            style={{
              color: "var(--text-muted)",
              fontSize: "0.9rem",
              marginTop: "1rem",
            }}
          >
            Redirecting to dashboard...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="container"
      style={{ marginTop: "20vh", textAlign: "center" }}
    >
      <div
        className="card"
        style={{ padding: "2rem", maxWidth: "400px", margin: "0 auto" }}
      >
        <h2 style={{ marginBottom: "1rem" }}>Resolving QR Code...</h2>
        <p style={{ color: "var(--text-secondary)" }}>
          Please wait while we load the item details.
        </p>
        <div style={{ marginTop: "1.5rem" }}>
          <div className="spinner"></div>
        </div>
      </div>
    </div>
  );
}

export default ScanRedirect;
